import { axiosInstance, isAuthenticated } from '../axios.ts';
import { IContactForm, INotification, IUser, PaginatedResponse } from '../types';
import { cleanCPFCNPJ, getPaginatedEndpoint, snakeCaseDictToCamelCaseDict } from '../utils.ts';

export async function getUserByCode(code: string): Promise<IUser> {
  code = cleanCPFCNPJ(code);
  return axiosInstance.get(`/user/cpf/${code}/`).then(({ data }) => snakeCaseDictToCamelCaseDict(data) as IUser);
}

export async function getProfile(): Promise<IUser | null> {
  if (!isAuthenticated()) return null;
  return axiosInstance.get(`/profile/`).then(({ data }) => snakeCaseDictToCamelCaseDict(data) as IUser);
}

export async function updateProfile(data: Record<string, string | boolean>): Promise<IUser | null> {
  if (!isAuthenticated()) return null;
  return axiosInstance.patch(`/profile/my/`, data).then(({ data }) => snakeCaseDictToCamelCaseDict(data) as IUser);
}

export async function getNotifications(): Promise<PaginatedResponse<INotification>> {
  return getPaginatedEndpoint(`/notifications/`);
}

export async function sendContactMessage(data: IContactForm): Promise<null> {
  return axiosInstance.post(`/contact/`, data);
}
